import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserOrganization } from '@typings';

export type UserOrganizationState = UserOrganization[];

const initialState = [] as UserOrganizationState;

export const userOrganizationsSlice = createSlice({
  name: 'userOrganizations',
  initialState,
  reducers: {
    setUserOrganizations: (_, action: PayloadAction<UserOrganizationState>) =>
      action.payload,
  },
});

export const { setUserOrganizations } = userOrganizationsSlice.actions;

export default userOrganizationsSlice.reducer;
